import { ButtonProps } from "@chakra-ui/react";
import React, { useCallback, useState } from "react";
import Confirm from "./Confirm";

export type ConfirmState = {
  isOpen: boolean;
  title?: string | React.ReactNode;
  message: string | React.ReactNode;
  buttons: (Omit<ButtonProps, "children"> & { text: string | React.ReactNode })[];
  loadingIndex: number;
  size?: "sm" | "md" | "lg" | "xl" | "2xl" | "full" | "xs" | "3xl" | "4xl" | "5xl" | "6xl"
};

const initialState: ConfirmState = {
  isOpen: false,
  loadingIndex: -1,
  title: "",
  message: "",
  buttons: [],
  size: "md",
};

export const ConfirmContext =
  React.createContext<
    (props: Pick<ConfirmState, "title" | "message" | "buttons" | "size">) => void
  >(null);

export default function ConfirmProvider({ children }) {
  const [confirmState, setConfirmState] = useState<ConfirmState>(initialState);

  const confirm = useCallback(
    ({
      title,
      message,
      buttons,
      size,
    }: Pick<ConfirmState, "title" | "message" | "buttons" | "size">) =>
      setConfirmState({
        isOpen: true,
        loadingIndex: -1,
        title,
        message,
        buttons,
        size
      }),
    []
  );

  const onClose = useCallback(() => {
    setConfirmState(initialState);
  }, []);

  const setLoadingIndex = useCallback((index: number) => {
    setConfirmState((prev) => ({ ...prev, loadingIndex: index }));
  }, []);

  return (
    <>
      <ConfirmContext.Provider value={confirm}>
        {children}
      </ConfirmContext.Provider>
      <Confirm
        {...confirmState}
        onClose={onClose}
        setLoadingIndex={setLoadingIndex}
      />
    </>
  );
}
